import {Injectable, Injector} from "@angular/core";
import {Visitor} from "./visitor";
import {CrudService, mapCollection} from "@mango/core";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class VisitorService extends CrudService<Visitor> {

  constructor(injector: Injector, protected http: HttpClient) {
    super(Visitor, injector);
  }

  getVisitors() {
    return this.get({
      properties: [
        "id",
        x => x.company.name,
        x => x.school.name,
        x => x.company.id,
        x => x.school.id
      ],
      filter: null,
      orderBy: [1]
    }).pipe(mapCollection()).toPromise();
  }
}
